import { faRefresh } from "@fortawesome/pro-regular-svg-icons";
import { noop } from "lodash-es";

import { useDashboardMetricsRefresh } from "src/analytics/dashboard/DashboardMetricsContext";
import { SubHeaderButton } from "src/layout/SubHeader";
import { formatDate } from "src/utils/datetime";

export const DashboardRefreshButton: React.FC = () => {
  const { refresh, isRefreshing, lastUpdatedAt } = useDashboardMetricsRefresh();
  return (
    <SubHeaderButton
      dataLoc="dashboard-refresh-button"
      icon={faRefresh}
      spin={isRefreshing}
      tooltip={
        lastUpdatedAt
          ? `last updated at ${formatDate(lastUpdatedAt, "HH:mm")}`
          : "Refresh"
      }
      onClick={isRefreshing ? noop : refresh}
    />
  );
};
